(function() {
'use strict';

function createTab(init) {
	const tab = this;

    init.setController( new TabControllerVue({
        el: '#vue-client-management',
		lockUpdates: true,

        methods: {
			resetData() {
				this.client               = null;
				this.clientData           = [];
				this.clientContacts       = [];
				this.clientAddresses      = [];
				this.clientDefaultContact = null;

				// Flags for showing whether a section is modified
				this.clientDataModified      = false;
				this.clientContactsModified  = false;
				this.clientAddressesModified = false;
			},

			getClient: function ( clientID, onSuccess, onError ) {
				const client = this.clients.find( client => client.id == clientID );
				if ( ! client ) { return onError( 'Client not found' ); }
				this.client = client;
				onSuccess( client );
			},

			loadClientData: function() {
				const _this = this;

				window.ajaxCall({
	                data : {
	                    action: 'get_client_data',
	                    client_id: _this.clientId,
	                },
	                successMessage: 'Successfully Loaded Client Data',
	                onSuccess : function( data ) {

						_this.lockUpdates( 'loadClientData' );

						// Temporarily store the data in separate variables
	                    const clientData      = data['data'];
	                    const clientContacts  = clientData.ClientContacts;
	                    const clientAddresses = clientData.ClientAddresses;

						// Remove this data because it is housed in a different variable
	                    delete clientData.ClientContacts;
	                    delete clientData.ClientAddresses;

	                    // add an empty address object to the contact data -- WHY?
	                    for ( let i = 0; i < clientContacts.length; i++ ) {
	                        clientContacts[i].ContactAddress = {};
	                    }

						// Update this Vue Model
						_this.clientData 		= clientData;
						_this.clientAddresses 	= clientAddresses;
						_this.clientContacts 	= clientContacts;
	                    _this.validateClientContactAddresses();

						_this.setClientDataModified 			= false;
						_this.setClientAddressesModified		= false;
						_this.setClientContactsModified 		= false;

						_this.unlockUpdatesLater( 'loadClientData' );
	                },
	            });
			},

			validateClientContacts: function() {
	            // updates the client object to reflect changes in the contact address select-one
	            // the select-one sets it as an object, we set it to just an id here
				const _this = this;
	            _.forEach( _this.clientContacts, function( contact ) {
	                contact.AddressID =
	                    ( contact.ContactAddress && contact.ContactAddress.id )
	                    ? contact.ContactAddress.id
	                    :  null;
	            });
	        },

			validateClientContactAddresses: function() {
	            // Look at each of the client contacts and if there is an AddressID set,
	            // set the current ContactAddress based on it.
				const _this = this;
	            _.forEach( _this.clientContacts, function( contact ) {
	                if ( contact.AddressID ) {
	                    _.forEach( _this.clientAddresses, function( address ) {
	                        if ( address.id == contact.AddressID ) {
	                            contact.ContactAddress = address;
	                        }
	                    });
	                }
	            });
	        },

            updateClientInfo: function() {
				const _this = this;

                window.ajaxCall({
                    data : {
                        action: 'update_client_data',
                        client_data: _this.clientData,
                    },
                    onSuccess : function( data ) {
						_this.clientDataModified = false;
                    },
                    onError : function() {},
                });
            },

            updateClientContacts: function() {
				const _this = this;

                window.ajaxCall({
                    data : {
                        action: 'update_client_contacts',
                        client_contacts: _this.clientContacts,
                    },
                    onSuccess : function( data ) {
                        _this.clientContactsModified = false;
                    },
                    onError : function() {},
                });
            },

            updateClientAddresses: function() {
				const _this = this;

                window.ajaxCall({
                    data : {
                        action: 'update_client_addresses',
                        client_addresses: _this.clientAddresses,
                    },
                    onSuccess : function( data ) {
                        _this.clientAddressesModified = false;
                    },
                    onError : function() {},
                });
            },

            addClient: function() {
				const _this = this;
                window.InputModalManager.show({
                    title 		: 'Add New Client',
                    inputText   : '',
                    buttonText	: 'Add Client',
                    callback 	: function( name ) {
                        if ( name ) {
							window.ajaxCall({
								data : {
									action: 'add_client',
									name: name,
								},
								onSuccess : function( data ) {
									const clientId = data['data'];
									const client = { id: clientId, text: name };

									store.commit( 'set', {
										fieldName: 'clientList',
										value: _this.clients.concat( client )
									});

									_this.client = client;

									window.broadcastLocalStorageUpdateRequest( 'clientList' );
								},
								onError : function() {},
							});
                        } else {
                            window.ajaxNotificationManager.warning( 'A name is required when adding a Client!' );
                        }
                    },
                });
            },

            renameClient: function() {
				const _this = this;

                window.InputModalManager.show({
                    title 		: 'Rename Client',
                    inputText   : _this.clientName,
                    buttonText	: 'Rename Client',
                    callback 	: function( name ) {
						if ( '' == name ) {
							window.WarningModalManager.show({
								message: 'A name is required when renaming a client!'
							});
						} else if ( name == _this.clientName ) {
							window.WarningModalManager.show({
								message: 'That is the existing name, no action will be taken'
							});
						} else {
							window.ajaxCall({
								data : {
									action: 'rename_client',
									client_id: _this.clientId,
									name: name,
								},
								successMessage: 'Successfully Renamed Client',
								onSuccess : function( data ) {
									window.broadcastLocalStorageUpdateRequest( 'clientList' );
								},
							});
							_this.clientName = name;

							window.broadcastLocalStorageUpdateRequest( 'clientList' );
                        }
                    },
                });
            },


			// Deactivate - Handle correctly on server...
            deleteClient: function() {
				const _this = this;
                window.ConfirmationModalManager.show({
                    title 		: 'Confirm Client Deletion',
                    message		: 'Are you sure you want to permanently delete the Client "'
                                    + this.clientName
                                    + '"?',
                    buttonText	: 'Delete',
                    callback 	: function() {
						window.ajaxCall({
							data : {
								action: 'delete_client',
								client_id: _this.clientId,
							},
							successMessage: 'Successfully Deleted Client',
							onSuccess : function( data ) {
								window.broadcastLocalStorageUpdateRequest( 'clientList' );
							},
						});
                        _this.reset();
                    },
                });
            },

            addClientContact: function() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'add_client_contact',
						client_id: _this.clientId,
					},
					onSuccess : function( data ) {
						const modified = this.clientContactsModified;
						const clientContact = data['data'];

						_this.clientContacts.push( clientContact );

						requestAnimationFrame( () => {
							_this.clientContactsModified = modified;
						});

					},
				});
            },

            deleteClientContact: function( clientContactId ) {
				const _this = this;
                window.ConfirmationModalManager.show({
                    title 		: 'Confirm Client Contact Deletion',
                    message		: 'Are you sure you want to permanently delete this Client Contact?',
                    buttonText	: 'Delete',
                    callback 	: function() {
                        const modified = _this.clientContactsModified;

						window.ajaxCall({
			                data : {
			                    action: 'delete_client_contact',
			                    client_contact_id: clientContactId,
			                },
			            });

						let currentIndex = null;
			            for( let index = 0; index < _this.clientContacts.length; index++ ) {
			                let contact = _this.clientContacts[index];
			                if ( contact.ContactID == clientContactId ) {
			                    currentIndex = index;
			                }
			            }

						if ( null !== currentIndex ) {
							_this.clientContacts.splice( currentIndex, 1 );
						}

                        _this.$nextTick( () => {
                            _this.clientContactsModified = modified;
                        });
                    },
                });
            },


            addClientAddress: function() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'add_client_address',
						client_id: _this.clientId,
					},
					onSuccess : function( data ) {
						const modified = this.clientAddressesModified;
						const clientAddress = data['data'];

						_this.clientAddresses.push( clientAddress );

						requestAnimationFrame( () => {
							_this.clientAddressesModified = modified;
						});

					},
				});
            },
			createClientAddressLabel: function( clientAddressId ) {
				const clientAddress = this.clientAddresses.find( address => address.AddressID == clientAddressId );
				const addressLocation = clientAddress.AddressCity + ', ' + clientAddress.AddressState + ' ' + clientAddress.AddressZip;
				const address = [
					this.clientData.ClientDisplayName,
					clientAddress.Address1,
					clientAddress.Address2,
					addressLocation
				].filter( x => x != '' && x != ', ' ).join( '\n' );
				const args = {
					title: 'Address Label',
					message: address,
				};
				window.InfoModalManager.show( args );
			},
            deleteClientAddress: function( clientAddressId ) {
				const _this = this;
                let args = {
                    title 		: 'Confirm Client Address Deletion',
                    message		: 'Are you sure you want to permanently delete this Client Address?',
                    buttonText	: 'Delete',
					callback 	: function() {
                        const modified = _this.clientAddressesModified;

						window.ajaxCall({
			                data : {
			                    action: 'delete_client_address',
			                    client_address_id: clientAddressId,
			                },
			            });

						const currentIndex = this.clientAddresses.findIndex( address => address.AddressID == clientAddressId );

						if ( -1 !== currentIndex ) {
							_this.clientAddresses.splice( currentIndex, 1 );
						}

                        _this.$nextTick( () => {
                            _this.clientAddressesModified = modified;
                        });
                    },
                };
                window.ConfirmationModalManager.show( args );
            },

			doElementAction: function(target, elClass, event) {
				if ( target.dataset.clientId )
					this.getClient( target.dataset.clientId,
						client => tab.show(),
						message => alert( message )
					);
				else {
					tab.show();
					this.addClient();
				}
			},
        },

        computed: {

			// Load locally loaded client list
            clients: _ => store.state.clientList,

			// get id from the selected client object ( id:id, text:clientName ) from clients array
			clientId: function() {
				if ( this.client ) {
					return this.client.id;
				}
				return '';
			},

			// get text from the selected client object ( id:id, text:clientName ) from clients array
            clientName: {
				get: function() {
					return null == this.client ? '' : this.client.text;
	            },
				set: function( name ) {
					if ( this.client ) {
						this.client.text = name;
					}
				},
			},


            clientAddressList: function() {
                return this.clientAddresses.map( function( address ) {
                    return {
                        id: address.AddressID,
                        text: [ address.Address1, address.Address2, address.AddressCity, address.AddressState + ' ' + address.AddressZip ]
                            .filter( x => x )
                            .join( ', ' )
                    }
                });
            },

            clientContactList: function() {
                return this.clientContacts.map( function( contact ) {
                    return {
                        id: contact.ContactID,
                        text: contact.ContactName,
                    }
                });
            },

			// Get a list of states for the address dropdowns...
            states: function() {
                return store.state.states;
            },

        },

        watch: {
            client: function() {
				// hide the collapsible sections on the page and repopulate the data
                if ( ! this.getUpdateLockLevel() ) {
                    this.loadClientData();
                }
            },
            clientData: {
                handler: function() {
					if ( ! this.getUpdateLockLevel() ) {
						this.clientDataModified = true;
						this.updateClientInfo();
					}
					const contactId = this.clientDefaultContact ? this.clientDefaultContact.id : null;
					if ( this.clientData.ClientDefaultContactID != contactId ) {
						this.clientDefaultContact = this.clientContactList.find(
							contact => contact.id == this.clientData.ClientDefaultContactID
						) || null;
					}
                },
                deep: true,
            },
            clientContacts: {
                handler: function() {
					if ( ! this.getUpdateLockLevel() ) {
                        this.validateClientContacts();
						this.clientContactsModified = true;
						this.updateClientContacts();
                    }
                },
                deep: true,
            },
            clientAddresses: {
                handler: function() {
					if ( ! this.getUpdateLockLevel() ) {
                        this.validateClientContactAddresses();
						this.clientAddressesModified = true;
						this.updateClientAddresses();
                    }
                },
                deep: true,
			},
			clientDefaultContact: function() {
				const contactId = this.clientDefaultContact ? this.clientDefaultContact.id : null;
				if ( this.clientData.ClientDefaultContactID != contactId ) {
					this.clientData.ClientDefaultContactID = this.clientDefaultContact ? this.clientDefaultContact.id : null;
				}
			},
        },

	}) );

}


const tab = AppTabs.createTab( {
	name: 'client-management',
	icon: 'users-cog',
	text: 'Client Management',
	actionElementClasses: [ 'client-link' ],
	create: createTab,
} );

})();
